import { Trans } from 'react-i18next'

import { ConditionFeatureFlag, ConditionStatementDateTime } from '@makyoapp/makyo-common'
import { Date16 } from '@makyoapp/makyo-icon/icon'

import VariableDateTime, { getDateTimeLabel } from '../VariableSelectV2/VariableDateTime'
import { useConditionRepeaterContext } from './ConditionRepeaterContext'
import { useConditionSelectContext } from './ConditionSelectContext'

export function ConditionDateTimeDD() {
  const { value, onChange } = useConditionRepeaterContext()
  const { setOpen, index, isRhs, isEnd } = useConditionSelectContext()

  return (
    <VariableDateTime
      onChange={(v) => {
        const valKey = isRhs && isEnd ? 'endValue' : 'value'

        const nextCond = [...value.conditions]
        nextCond[index] = {
          ...nextCond[index],
          rhs: {
            ...nextCond[index].rhs,
            flag: ConditionFeatureFlag.DateTime,
            [valKey]: v.variant,
          } as ConditionStatementDateTime,
        }
        onChange?.({
          isAny: value.isAny,
          conditions: nextCond,
        })
        setOpen(false)
      }}
    />
  )
}

export function ConditionDateTimeStatement({ statement }: { statement: ConditionStatementDateTime }) {
  const { isRhs, isEnd } = useConditionSelectContext()
  const valKey = isRhs && isEnd ? 'endValue' : 'value'
  return (
    <div className='flex-c min-w-0'>
      <Date16 width={14} height={14} />
      <div className='txt'>
        <Trans>{getDateTimeLabel(statement[valKey] as any)}</Trans>
      </div>
    </div>
  )
}
